import { render, staticRenderFns } from "./EventSettingsBase.vue?vue&type=template&id=010f97e2&"
import script from "./EventSettingsBase.vue?vue&type=script&lang=js&"
export * from "./EventSettingsBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports